export default __webpack_public_path__ + "static/media/BA14.d59be716.jpg";